import { DocumentNode, GraphQLError } from "graphql";
import useSWR, { ConfigInterface, keyInterface } from "swr";
import type { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";
import { client } from "~lib";
import { useContext } from "react";
import { BaseContext } from "~context";
import { Variables } from "graphql-request";

export const generateKey = <T extends DocumentNode>(
  query: T,
  variables?: VariablesOf<T>
): keyInterface => {
  return query ? JSON.stringify([query, variables ?? {}]) : null;
};

export const useQuery = <T extends DocumentNode>(
  query: T,
  variables?: VariablesOf<T>,
  options: ConfigInterface<ResultOf<T>, GraphQLError> = {}
) => {
  const { organization } = useContext(BaseContext);

  const key = generateKey(query, variables);
  const results = useSWR<ResultOf<T>, GraphQLError>(
    key,
    async () => client(organization?.id).request(query, variables as Variables),
    options
  );

  const isLoading =
    key && typeof results.data === "undefined" && !results.error;

  return { ...results, key, isLoading };
};
